import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Containers/login-page/login-page/index.jsx";
import ForgotPasswordPage from "./Containers/login-page/forgot-password/index.jsx";
import VerifyOtpPage from "./Containers/login-page/verify-otp/index.jsx";
import ResetPasswordPage from "./Containers/login-page/reset-password/index.jsx";
import ProtectedRoute from "./Utils/ProtectedRoutes";
import AdminLayout from "./Components/Layout/AdminLayout";
import routes from "./Utils/routes";
import useHtpp from "./Utils/useHttps";
import { useEffect, useMemo, useState } from "react";
import {
  filterRoutesByPermissions,
  getFirstAllowedPath,
  getStoredUser,
  PermissionProvider,
} from "./Utils/permissionAccess";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [permissionUser, setPermissionUser] = useState(getStoredUser());
  const { configureHeaders, configureInterceptors } = useHtpp();
  useEffect(() => {
    configureHeaders();
    configureInterceptors();
  }, [configureHeaders, configureInterceptors]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setPermissionUser(getStoredUser());
  };

  const allowedRoutes = useMemo(
    () => filterRoutesByPermissions(routes, permissionUser),
    [permissionUser],
  );
  const firstAllowedPath = useMemo(
    () => getFirstAllowedPath(allowedRoutes) || "/profile",
    [allowedRoutes],
  );

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to={firstAllowedPath} replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/login"
          element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
        />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/verify-otp" element={<VerifyOtpPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route
          path="/*"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn} onUserLoaded={setPermissionUser}>
              <PermissionProvider user={permissionUser}>
                <AdminLayout permissionUser={permissionUser}>
                  <Routes>
                    {(() => {
                      const getAllRoutes = (items) => {
                        return items.reduce((acc, item) => {
                          if (item.path && item.element) {
                            acc.push(
                              <Route
                                key={item.path}
                                path={item.path}
                                element={<item.element />}
                              />
                            );
                          }
                          if (item.children) {
                            acc.push(...getAllRoutes(item.children));
                          }
                          return acc;
                        }, []);
                      };
                      return [
                        ...getAllRoutes(allowedRoutes),
                        <Route
                          key="permission-fallback"
                          path="*"
                          element={<Navigate to="/unauthorized" replace />}
                        />,
                      ];
                    })()}
                  </Routes>
                </AdminLayout>
              </PermissionProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
